import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Capacitor } from '@capacitor/core';
import PushNotificationService from './services/PushNotifications';
import AnalyticsService from './services/Analytics';
import { logger } from './utils/logger';

// Global Error Handler for White Screen of Death
window.addEventListener('error', (event) => {
  const message = event.message || '';
  const filename = event.filename || '';
  
  // Ignorar erros genéricos de scripts de terceiros (cross-origin / CORS sanitizado)
  const isScriptError = message.toLowerCase().includes('script error');
  
  // Ignorar erros disparados por extensões do navegador (como gerenciadores de senha, adblockers, compartilhamento de iOS)
  const isExtension = filename.includes('extension://') || 
                      filename.includes('chrome-extension://') || 
                      filename.includes('safari-extension://') ||
                      filename.includes('safari-web-extension://');

  if (isScriptError || !filename || isExtension) {
    logger.warn('[GlobalError] Ignorando erro externo/sanitizado:', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno
    });
    return;
  }

  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `<div style="color: red; padding: 20px; font-family: sans-serif;">
      <h1>Erro Fatal na Aplicação</h1>
      <p>${event.message}</p>
      <pre>${event.filename}: ${event.lineno}</pre>
    </div>`;
  }
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  logger.error("FATAL: Could not find root element to mount to");
  throw new Error("Could not find root element to mount to");
}

logger.log("Iniciando aplicação Cognitya...");

// Service Worker registration process is handled by PWAUpdateBanner using vite-plugin-pwa
if ('serviceWorker' in navigator) {
  // Apenas log de suporte, o registro real é feito pelo componente de UI ou virtual:pwa-register
  logger.log('[SW] Browser suporta Service Workers');
}
// Inicializar Push Notifications (apenas em apps nativos)
if (Capacitor.isNativePlatform()) {
  logger.log('[Capacitor] Plataforma nativa detectada');

  // Inicializar Analytics
  AnalyticsService.initialize();

  // Aguardar autenticação antes de registrar push (será chamado após login)
  // PushNotificationService.initialize() será chamado nos dashboards
}

try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  logger.log("React montado com sucesso.");
} catch (error: any) {
  logger.error("Erro fatal ao montar React:", error);
  rootElement.innerHTML = `<div style="color: red; padding: 20px;">
    <h1>Erro ao Montar React</h1>
    <pre>${error?.message || JSON.stringify(error)}</pre>
  </div>`;
}